import Http from "./http";

const login = async (username, password) => {
  let response = await Http.post('/authenticate', { username, password })
  if (response.data.token) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }
  return response.data || "Erro na solicitaçao";
}

const logout = () => {
  localStorage.removeItem("user");
}

export const userService = {
  login,
  logout
}